


























import { Component, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import CampaignStatus from '@/models/Campaigns/CampaignStatus';

import UpdateCampaignStatusRequest from '@/models/Campaigns/UpdateCampaignStatusRequest';

@Component({
    name: 'CampaignStatusSet',
})
export default class extends GiganautVueDialog {
 
  campaignStatus = CampaignStatus;

  menu = false;

  get campaign() {
    return CampaignDetailsModule.currentCampaign;
  }

  async setStatusToClosed() {
    const request = new UpdateCampaignStatusRequest();
    request.updatedAt = CampaignDetailsModule.currentCampaign.updatedAt;
    request.status = CampaignStatus.Closed;
    await CampaignDetailsModule.updateCampaignStatus(request);
  }
}
